/* eslint-disable react/require-default-props */
import React from 'react';
import { motion } from 'framer-motion/dist/framer-motion';
import clsx from 'clsx';
import useStyles from './styles';

interface AnimatedFadeProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const AnimatedFade = ({
  children,
  className,
  style,
  loading,
  id,
  onClick,
}: AnimatedFadeProps) => {
  const classes = useStyles({ loading });

  const variants = {
    fadeOut: { opacity: [1, 0], transition: { duration: 0.8 } },
    fadeIn: { opacity: [0, 1], transition: { duration: 0.8 } },
  };

  return (
    <motion.div
      id={id}
      variants={variants}
      className={clsx(classes.overlayEffect, className)}
      style={style}
      onClick={onClick}
      {...(loading && { animate: loading ? 'fadeOut' : 'fadeIn' })}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedFade;
